import { Resource } from "./schema";

export enum TaskStatus {
  ToDo = "TODO",
  Blocked = "BLOCKED",
  InProgress = "IN_PROGRESS",
  ReadyForReview = "READY_FOR_REVIEW",
  Cancelled = "CANCELLED",
  Done = "DONE",
}

export interface AlignmentTaskConfig {
  /**
   * the tag that gets applied to the item to reserve it from future alignment
   * tasks
   * */
  objectiveAlignmentProjectId?: string;
  sourceObjectiveSection?: string;
  targetObjectiveDocument?: string;
}

export interface AlignmentTask extends Resource {
  config: AlignmentTaskConfig;
}
